import React from 'react'
import s from './divider.scss'

export const Divider = () => <div className={s.divider} />
